import { useRef, type KeyboardEvent } from "react";
import { Badge, Field, Input } from "@/components/ui";
import { focusNextField, type AutoCode } from "./auto-code";

/**
 * Campo Código dos cadastros. Vazio = automático. Enter com o campo vazio mostra o próximo
 * código ("previsto") e passa ao próximo campo; Enter com código digitado só passa adiante.
 */
export function CodeField({
  auto,
  value,
  onChange,
  error,
  disabled,
  autoFocus,
}: {
  auto: AutoCode;
  value: string;
  onChange: (value: string) => void;
  error?: string | undefined;
  disabled?: boolean;
  autoFocus?: boolean;
}) {
  const ref = useRef<HTMLInputElement | null>(null);
  const previsto = auto.preview !== null && value === auto.preview;

  async function onKeyDown(e: KeyboardEvent<HTMLInputElement>) {
    if (e.key !== "Enter") return;
    e.preventDefault();
    if (value.trim() === "") {
      const code = await auto.fetchPreview();
      if (code) onChange(code);
    }
    focusNextField(ref.current);
  }

  return (
    <Field
      label="Código"
      error={error}
      hint={
        previsto
          ? "Previsto: o código definitivo é dado ao salvar"
          : "Automático: gerado ao salvar (Enter mostra o próximo)"
      }
    >
      <div className="relative">
        <Input
          ref={ref}
          value={value}
          placeholder="Automático"
          {...(disabled !== undefined ? { disabled } : {})}
          {...(autoFocus ? { autoFocus } : {})}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={(e) => void onKeyDown(e)}
        />
        {previsto && (
          <span className="pointer-events-none absolute right-2 top-2">
            <Badge>previsto</Badge>
          </span>
        )}
      </div>
    </Field>
  );
}
